<template>
  <div class="Description">
      <div class="button-container">
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="row">
              <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
                <h4>Risk Disclosure and Product Suitability</h4>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4">
                <button @click="next" class="submit next">Next<i class="fa fa-angle-right"></i></button>
              </div>
            </div>
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="lesson-author">
              <div lass="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="row">
                  <span class="lesson"></span>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                    <span class="mentor">Lesson 1</span>
                    <p>Capital Markets & Derivatives</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Description',

  methods: {
    next() {
      this.$router.push('/quiz');
    },
  },
};
</script>

<style lang="scss" scoped>
.Description {
  margin-top: -20px;
  .button-container {
    margin: 0 85px 0 auto;
  }
  .next {
    background: transparent linear-gradient(263deg, #68ffed, #0575e6) repeat
      scroll 0 0;
    border: medium none;
    border-radius: 29px;
    box-shadow: 0 6px 8px 0 rgba(94, 105, 119, 0.2);
    color: #ffffff;
    cursor: pointer;
    font-size: 18px;
    height: 46px;
    line-height: 32px;
    padding: 0 41px;
    font-weight: 300;
    letter-spacing: 2px;
    float: right;
    margin: 30px 0 30px 0;
  }
  .next:hover,
  .next:focus {
    background: #fff;
    border: 2px solid #34cdfb;
    color: #34cdfb;
  }
  .submit .fa {
    font-size: 14px;
  }
  .fa-angle-right {
    font-size: 18px;
    opacity: 0;
    position: relative;
    left: 0px;
    -webkit-transition: all 0.5s linear;
    -moz-transition: all 0.5s linear;
    -o-transition: all 0.5s linear;
    transition: all 0.5s linear;
  }
  .submit:hover .fa-angle-right {
    font-size: 18px;
    opacity: 1;
    left: 15px;
  }
  h4{
    margin: 30px 0 30px 26px;
  }
  .lesson-author {
    color: #28282e;
    font-size: 20px;
    font-weight: 300;
    margin: 20px 0 53px;
    line-height: 54px;
  }

  .lesson {
    margin: 20px 10px 0 35px;
    position: relative;
    padding: 0;
  }

  .lesson::after {
    background: #000000 none repeat scroll 0 0;
    border-radius: 100%;
    content: "";
    height: 7px;
    left: 11px;
    position: absolute;
    top: 6px;
    width: 7px;
  }
  .mentor {
    color: #000000;
    font-family: "Poppins";
    font-weight: 500;
    span {
      font-weight: 300;
    }
  }

  p {
    color: #000000;
    font-family: "Poppins";
    width: 80vw;
  }
  @media (max-width: 600px) {
    h4{
      font-size: 20px;
    }
    .next{
      font-size: 14px;
      height: 37px;
      line-height: 32px;
      padding: 0 29px;
    }
  }
  @media (min-width: 375px) {
    .button-container {
      padding-left: 40px;
    }
  }
  @media (max-width: 375px) {
    .button-container {
      padding-left: 30px;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/Home/components/Description.vue